export default "__VITE_ASSET__9017938f__"